const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297 - 50;
const DPI = 70; // Можно изменить в зависимости от требований
const A4_WIDTH_PX = Math.round(A4_WIDTH_MM * (DPI / 25.4));
const A4_HALF_HEIGHT_PX = Math.round((A4_HEIGHT_MM / 2) * (DPI / 25.4)); // Половина высоты листа A4 для одного изображения

interface ImageDimensions {
  width: number;
  height: number;
  aspectRatio: number;
}

const getImageDimensions = (base64: string): Promise<ImageDimensions> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;

    img.onload = () => {
      const { width, height } = img;
      const aspectRatio = width / height;

      resolve({
        width,
        height,
        aspectRatio
      });
    };
  });
};

const fitImageToA4 = (
  dimensions: ImageDimensions
): { width: number; height: number } => {
  const { aspectRatio } = dimensions;

  // Шаг 1: Пробуем растянуть по ширине A4
  let newWidth = A4_WIDTH_PX;
  let newHeight = Math.round(newWidth / aspectRatio);

  // Шаг 2: Если высота превышает половину A4, подстраиваем по высоте
  if (newHeight > A4_HALF_HEIGHT_PX) {
    newHeight = A4_HALF_HEIGHT_PX;
    newWidth = Math.round(newHeight * aspectRatio);
  }

  return {
    width: newWidth,
    height: newHeight
  };
};

const rotateImageToLandscape = (base64: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = `data:image/jpeg;base64,${base64}`;

    img.onload = () => {
      const { width, height } = img;
      const isSquare = Math.abs(width / height - 1) < 0.01; // Tolerance for near-square images
      const needsRotation = width < height && !isSquare;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }

      // Set canvas dimensions based on rotation needs
      canvas.width = needsRotation ? height : width;
      canvas.height = needsRotation ? width : height;

      // Save context state
      ctx.save();

      if (needsRotation) {
        // Translate to rotate around the center
        ctx.translate(height / 2, width / 2);
        // Rotate 90 degrees clockwise
        ctx.rotate(Math.PI / 2);
        // Draw image centered
        ctx.drawImage(img, -width / 2, -height / 2);
      } else {
        // Draw image as is
        ctx.drawImage(img, 0, 0);
      }

      ctx.restore();

      const rotatedBase64 = canvas.toDataURL('image/jpeg', 1);
      resolve(rotatedBase64);
    };

    img.onerror = () => reject(new Error('Failed to load image'));
  });
};

export const rotateAndFitImage = async (base64: string) => {
  const rotatedBase64 = await rotateImageToLandscape(base64);
  const dimensions = await getImageDimensions(rotatedBase64);
  const { width, height } = fitImageToA4(dimensions);
  return { width, height, base64: rotatedBase64.split(',')[1] };
};
